module.exports = __webpack_public_path__ + "img/No genera exposición en la centra de riesgo.3d69c1f2.svg";